<figure class="tile">
    <img class="tile__avatar" src="{{user.avatar}}" alt="avatar">
    <figcaption class="tile__description">
        <p>{{user.first_name}}</p>
        <p>{{user.last_name}}</p>
        <a href="mailto:{{user.email}}">{{user.email}}</a>
    </figcaption>
</figure>